import { BroadcastChannel } from 'broadcast-channel';
import { PubSubMessage, PubSubMessageType } from './types';

type Listener = (message: PubSubMessage) => void;
type Listeners = Record<PubSubMessageType, Listener[]>;

/**
 * Relays messages from the host's worker to the sibling tabs using a broadcast channel
 */
export default class MessageProxy {
  public constructor(
    public broadcastChannel: BroadcastChannel<PubSubMessage>,
  ) {
    broadcastChannel.addEventListener('message', this.onBroadcastMessage);
  }

  /**
   * MessageEvent handler which should be attached to a Worker instance.
   * Broadcasts each message so other tabs can have access to them too.
   */
  public onWorkerMessage = async (event: MessageEvent<PubSubMessage>) => {
    // Notify other tabs of the message
    this.broadcastChannel.postMessage(event.data);
    // We "broadcast" the message to ourselves too :)
    this.onBroadcastMessage(event.data);
  };

  /**
   * Listen to broadcast channel for incoming messages
   */
  private onBroadcastMessage = (event: PubSubMessage) => {
    if (event.type === 'message') {
      this.listeners.message.forEach(listener => listener(event));
    }
  };

  private listeners: Listeners = {
    close: [],
    message: [],
  };

  /**
   * Add event listeners to me notified about new messages
   */
  public on(type: 'close', fn: (data: PubSubMessage) => void): void;
  public on(type: 'message', fn: (data: PubSubMessage) => void): void;
  public on(type: PubSubMessageType, fn: (data: PubSubMessage) => void): void {
    this.listeners[type]?.push(fn);
  }
}
